// extracted by mini-css-extract-plugin
export default {"formItem":"TuwXP","hidden":"Ckhzy","viewPrimary":"RcEl8","label":"Mqlxh","viewSecondary":"SsRpG","simple":"XA6Up","wide":"yc_5D","content":"KZfUo","bottom":"PkMGg","inModal":"uBNEW"};